import * as firebaseDb from '@mlc/firebase-config';

export const environment = {
  production: false,
  demo: false,
  regression: false,
  dev: true,
  db: firebaseDb.dev,
  useEmulators: false,
  useMockData: true,
};
